enum ActionType {
    INCIDENT_HELP_FEEDBACK = '[FEEDBACK TRIGGERED] INCIDENT HELP',
    INCIDENT_CLOSED_FEEDBACK = '[FEEDBACK TRIGGERED] INCIDENT CLOSED',
    INCIDENT_UNASSIGNED_FEEDBACK = '[FEEDBACK TRIGGERED] INCIDENT UNASSIGNED',
    FEEDBACK_CLOSED = '[FEEDBACK CLOSED]',
}

export default ActionType
